module.exports = __webpack_public_path__ + "media/images/ohap_my apps_off-f0bf951fe6e7a4fea5c9c046507bd4e1.png";